import ConstituentSearchColumn from '@/constants/ConstituentSearchColumn';

const ColumnsLabelMap = {
  [ConstituentSearchColumn.DISPLAY_NAME]: 'DISPLAY_NAME_LABEL',
  [ConstituentSearchColumn.DEVELOPERS]: 'ASSIGNEE',
  [ConstituentSearchColumn.CONSTITUENT_RULES]: 'column',
  [ConstituentSearchColumn.CONSTITUENT_CATEGORIES]: 'CATEGORIES',
  [ConstituentSearchColumn.LAST_INTERACTION_DATE]: 'LAST_INTERACTION',
  [ConstituentSearchColumn.PRIMARY_PHONE]: 'PHONE_NUMBERS_LABEL',
  [ConstituentSearchColumn.BIO]: 'BIOGRAPHY_LABEL',
  [ConstituentSearchColumn.LABELS]: 'CONSTITUENT_LABELS',
  [ConstituentSearchColumn.DATE_OF_BIRTH]: 'BIRTHDAY_LABEL',
  [ConstituentSearchColumn.PRIMARY_EMAIL]: 'EMAIL_ADDRESSES_LABEL',
  [ConstituentSearchColumn.PRIMARY_CITY]: 'CITY_LABEL',
  [ConstituentSearchColumn.PRIMARY_STATE]: 'STATE_LABEL',
  [ConstituentSearchColumn.PRIMARY_COUNTRY]: 'COUNTRY_LABEL',
  [ConstituentSearchColumn.IS_DECEASED]: '',

  [ConstituentSearchColumn.INSTAGRAM]: 'INSTAGRAM_LABEL',
  [ConstituentSearchColumn.TWITTER]: 'TWITTER_LABEL',
  [ConstituentSearchColumn.LINKEDIN]: 'LINKEDIN_LABEL',
  [ConstituentSearchColumn.FACEBOOK]: 'FACEBOOK_LABEL',
  [ConstituentSearchColumn.YOUTUBE]: 'YOUTUBE_LABEL',
  [ConstituentSearchColumn.TIKTOK]: 'TIKTOK_LABEL',

  [ConstituentSearchColumn.LIFETIME_COUNT]:
    'DONOR_CONTRIBUTIONS_LIFETIME_COUNT',
  [ConstituentSearchColumn.LIFETIME_DONATIONS]: 'DONOR_CONTRIBUTIONS_LIFETIME',
  [ConstituentSearchColumn.LIFETIME_HOURS]: 'DONOR_CONTRIBUTIONS_LIFETIME_TIME',
  [ConstituentSearchColumn.THIS_YEAR_COUNT]: 'DONOR_CONTRIBUTIONS_CY_COUNT',
  [ConstituentSearchColumn.THIS_YEAR_DONATIONS]: 'DONOR_CONTRIBUTION_CY',
  [ConstituentSearchColumn.THIS_YEAR_HOURS]: 'DONOR_CONTRIBUTIONS_CY_TIME',
  [ConstituentSearchColumn.NUM_CONNECTIONS]: 'CONNECTIONS_LABEL',

  [ConstituentSearchColumn.CUSTOM_FIELDS]: 'CUSTOM_FIELDS',

  // Not currently used
  [ConstituentSearchColumn.AVATAR]: '',
  [ConstituentSearchColumn.INCOMPLETE_TASKS]: '',
};

export default ColumnsLabelMap;
